
if (!customElements.get("cart-remove")) {
  class CartRemove extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClickViaLine.bind(this);
    }

    async getCurrentCartItems() {
      const response = await fetch('/cart.js', { method: "GET" });
      const cartJSON = await response.json();

      return cartJSON.items;
    }

    async handleClickViaLine(event) {
      /* Fix for item keys not working:
        Shopify API is currently disregarding item keys and only using the variant ID portion of the key
        This impacts updating items that may have the same variant ID, like bundle items
        In order to update bundle items correctly, we are using the array of numbers send to update.js
        This requires sending an array of quantities for every item in the cart
      */
      event.preventDefault();

      const cartItems = await this.getCurrentCartItems();

      // Create an array of current cart quantities
      const updates = cartItems.map((item) => item.quantity);

      const keys = this.getAttribute("data-keys").split(',');
      keys.forEach(key => {
        let keyIndex = cartItems.map((item) => item.key).indexOf(key);
        if (keyIndex > -1) {
          updates[keyIndex] = 0;
        }
      });

      // Remove related coolers
      if (this.hasAttribute("data-coolers")) {
        const coolers = this.dataset.coolers.split(',');

        coolers.forEach(cooler => {
          let keyIndex = cartItems.map((item) => item.variant_id).indexOf(cooler);
          if (keyIndex > -1) {
            updates[keyIndex] = 0;
          }
        });
      }

      // Remove related warm weather variant
      if (this.hasAttribute("data-warm-weather-variant")) {
        let variantId = this.getAttribute("data-warm-weather-variant");
        let keyIndex = cartItems.map((item) => item.variant_id).indexOf(variantId);
        if (keyIndex > -1) {
          updates[keyIndex] = 0;
        }
      }

      // Standard update.js POST, same as in handleClick
      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    handleClick(event) {
      event.preventDefault();

      const updates = {};
      const keys = this.getAttribute("data-keys").split(',');

      keys.forEach(key => {
        updates[key] = 0;
      });

      if (this.hasAttribute("data-coolers")) {
        const coolers = this.dataset.coolers.split(',');

        coolers.forEach(cooler => updates[cooler] = 0);
      }

      if (this.hasAttribute("data-warm-weather-variant")) {
        updates[`${this.getAttribute("data-warm-weather-variant")}`] = 0;
      }

      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("cart-remove", CartRemove);
}
